
const SOCIAL_HOSTS = [
  [/^(www\.)?instagram\.com$|^instagr\.am$/, 'instagram'],
  [/^(www\.)?facebook\.com$|^(www\.)?fb\.com$|^fb\.watch$/, 'facebook'],
  [/^(www\.)?twitter\.com$|^(www\.)?x\.com$/, 'twitter'],
  [/^(www\.)?linkedin\.com$|^lnkd\.in$/, 'linkedin'],
  [/^(www\.)?tiktok\.com$|^vm\.tiktok\.com$/, 'tiktok'],
  [/^(www\.)?youtube\.com$|^youtu\.be$/, 'youtube'],
  [/^(www\.)?snapchat\.com$/, 'snapchat'],
  [/^(www\.)?pinterest\.[a-z.]+$|^pin\.it$/, 'pinterest'],
  [/^(www\.)?twitch\.tv$/, 'twitch'],
  [/^(www\.)?discord\.(gg|com)$/, 'discord'],
  [/^t\.me$|^(www\.)?telegram\.(me|org)$/, 'telegram'],
  [/^(www\.)?reddit\.com$/, 'reddit'],
  [/^(www\.)?medium\.com$/, 'medium'],
  [/^(www\.)?behance\.net$/, 'behance'],
  [/^(www\.)?dribbble\.com$/, 'dribbble'],
  [/^wa\.me$|^(www\.)?whatsapp\.com$/, 'whatsapp'],
  [/^(www\.)?spotify\.com$|^spotify\.fi$/, 'spotify'],
  [/^music\.apple\.com$/, 'apple'],
  [/^(www\.)?soundcloud\.com$/, 'soundcloud'],
  [/^(www\.)?patreon\.com$/, 'patreon'],
  [/^(www\.)?github\.com$/, 'github'],
  [/^(www\.)?gitlab\.com$/, 'gitlab'],
  [/^(www\.)?threads\.(net|com)$/, 'threads'],
  [/^(www\.)?vimeo\.com$/, 'vimeo'],
  [/^(www\.)?tumblr\.com$/, 'tumblr'],
  [/^(www\.)?flickr\.com$/, 'flickr'],
  [/^(www\.)?deezer\.com$/, 'deezer'],
  [/^(www\.)?bandcamp\.com$/, 'bandcamp'],
  [/^(www\.)?stackoverflow\.com$/, 'stackoverflow'],
  [/^(www\.)?yelp\.[a-z.]+$/, 'yelp'],
  [/^(www\.)?etsy\.com$/, 'etsy'],
  [/^(www\.)?amazon\.[a-z.]+$/, 'amazon'],
  [/^(www\.)?paypal\.(com|me)$/, 'paypal'],
]

function parseUrl(raw = '') {
  const value = String(raw).trim()
  if (!value) return null

  try {
    return new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`)
  } catch {
    return null
  }
}

export function detectPlatform(raw = '') {
  const value = String(raw).trim()
  if (!value) return null

  if (/^mailto:/i.test(value)) return 'email'
  if (/^tel:/i.test(value)) return 'phone'

  const url = parseUrl(value)
  if (!url) return null

  const host = url.hostname.toLowerCase().replace(/^www\./, '')
  return SOCIAL_HOSTS.find(([regex]) => regex.test(host))?.[1] || null
}

export function getVideoEmbed(raw = '') {
  const url = parseUrl(raw)
  if (!url) return null

  const host = url.hostname.toLowerCase().replace(/^(www\.|m\.)/, '')
  const path = url.pathname.split('/').filter(Boolean)

  // Vidéo directe
  if (/\.(mp4|webm|ogg|mov)$/i.test(url.pathname)) {
    return { kind: 'file', src: url.href }
  }

  // YouTube
  let youtubeId = null

  if (host === 'youtu.be') {
    youtubeId = path[0]
  } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    youtubeId =
      url.searchParams.get('v') ||
      (['embed', 'shorts', 'live', 'v'].includes(path[0]) ? path[1] : null)
  }

  if (youtubeId && /^[a-zA-Z0-9_-]{11}$/.test(youtubeId)) {
    const start = parseInt(
      url.searchParams.get('t') || url.searchParams.get('start') || '0',
      10
    )

    return {
      kind: 'iframe',
      ratio: path[0] === 'shorts' ? '9/16' : '16/9',
      maxWidth: path[0] === 'shorts' ? 325 : undefined,
      src: `https://www.youtube-nocookie.com/embed/${youtubeId}${start > 0 ? `?start=${start}` : ''}`,
    }
  }

  // Vimeo
  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const id = [...path].reverse().find((part) => /^\d+$/.test(part))

    if (id) {
      return {
        kind: 'iframe',
        ratio: '16/9',
        src: `https://player.vimeo.com/video/${id}`,
      }
    }
  }

  // TikTok
  if (host === 'tiktok.com' || host === 'vm.tiktok.com') {
    const index = path.indexOf('video')
    const id = index >= 0 ? path[index + 1] : null

    if (id && /^\d+$/.test(id)) {
      return {
        kind: 'iframe',
        ratio: '9/16',
        maxWidth: 325,
        src: `https://www.tiktok.com/embed/v2/${id}`,
      }
    }
  }

  // Instagram Reel / Post / TV
  if (
    host === 'instagram.com' &&
    ['p', 'reel', 'reels', 'tv'].includes(path[0]) &&
    path[1]
  ) {
    return {
      kind: 'iframe',
      ratio: '9/16',
      maxWidth: 400,
      src: `https://www.instagram.com/${path[0]}/${path[1]}/embed`,
    }
  }

  // Facebook
  if (host === 'facebook.com' || host === 'fb.watch') {
    return {
      kind: 'iframe',
      ratio: '16/9',
      src: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url.href)}&show_text=false`,
    }
  }

  // Dailymotion
  if (host === 'dailymotion.com' || host === 'dai.ly') {
    const index = path.indexOf('video')
    const id = host === 'dai.ly' ? path[0] : path[index + 1]

    if (id) {
      return {
        kind: 'iframe',
        ratio: '16/9',
        src: `https://www.dailymotion.com/embed/video/${id}`,
      }
    }
  }

  // Twitch
  if (host === 'twitch.tv') {
    const parent = typeof window !== 'undefined'
      ? window.location.hostname
      : 'localhost'

    if (path[0] === 'videos' && path[1]) {
      return {
        kind: 'iframe',
        ratio: '16/9',
        src: `https://player.twitch.tv/?video=${path[1]}&parent=${parent}&autoplay=false`,
      }
    }

    if (path[0]) {
      return {
        kind: 'iframe',
        ratio: '16/9',
        src: `https://player.twitch.tv/?channel=${path[0]}&parent=${parent}&autoplay=false`,
      }
    }
  }

  // Loom
  if (host === 'loom.com' && path[0] === 'share' && path[1]) {
    return {
      kind: 'iframe',
      ratio: '16/9',
      src: `https://www.loom.com/embed/${path[1]}`,
    }
  }

  return null
}
